import { Component, Input } from '@angular/core';

/**
 * Consentimentos dados pelo utilizador (ConsentListDetails), agrupados por módulo/projeto,
 * como checkboxes marcadas e só de leitura. Com `File.Path` o nome é um link para o documento.
 */
@Component({
    selector: 'consents-list',
    templateUrl: './consents-list.component.html',
    styleUrls: ['./consents-list.component.scss'],
})
export class ConsentsListComponent {

    @Input('consents') Consents: any[] = [];
}
